<script setup lang="ts">
import type {
  NewProduct,
  NewProductModification,
} from '@/types/api/api-v4/product'
import { ProductDetailType } from '@/types/components/product-card.types'

type Props = {
  type: ProductDetailType
  product: NewProduct
  currentModification: NewProductModification
}

const props = defineProps<Props>()

const { isMobile } = useDevice()

const { productTitle, productImageList, productImage, setError } =
  useProductImage(props)

const sliderOptions = computed(() => {
  return {
    slideWidth: isMobile ? 350 : 426,
    dotsOffset: isMobile ? 4 : 8,
  }
})
</script>

<template>
  <div class="product-detail-image">
    <the-slider
      v-if="productImageList.length"
      class="product-detail-image__slider"
      :slide-width="sliderOptions.slideWidth"
      :space-between="10"
      :arrows="!isMobile"
      :length="productImageList.length"
      :dots-offset="sliderOptions.dotsOffset"
      dots
    >
      <nuxt-img
        v-for="image in productImageList"
        :key="image"
        :src="image"
        :title="productTitle"
        :alt="product.name"
        class="product-detail-image__media"
        loading="lazy"
        format="webp"
      />
    </the-slider>

    <nuxt-img
      v-else
      :src="productImage"
      :title="productTitle"
      :alt="product.name"
      class="product-detail-image__media"
      loading="lazy"
      format="webp"
      @error="setError(true)"
    />
  </div>
</template>

<style scoped lang="scss">
.product-detail-image {
  width: 100%;

  @include media('>=tablet') {
    max-width: 426px;
  }

  &__slider {
    margin-bottom: 26px;
  }

  &__media {
    display: block;
    width: 100%;
    height: 205px;
    object-fit: contain;
    border-radius: 16px;

    @include media('>=tablet') {
      height: 284px;
    }
  }
}
</style>
